<template>
  <div class="app-container" v-loading="this.isLoading">
    <el-form ref="form" label-width="300px">
      <MyFormItem label="UserId" tooltip="">
        <el-input class="form-input" v-model="modifyCupValue.userId" size="normal" clearable/>
      </MyFormItem>

      <MyFormItem label="TypeLb" tooltip="">
        <el-select v-model="modifyCupValue.typeLb" placeholder="Select" style="width: 240px">
          <el-option
              v-for="item in modifyCupValue.typeLbOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          />
        </el-select>
      </MyFormItem>

      <MyFormItem label="ModifyValue" tooltip="">
        <el-input-number v-model="modifyCupValue.modifyValue" :step="1" size="small"/>
      </MyFormItem>

      <el-table :data="modifyCupValue.result" border v-if="modifyCupValue.result.length > 0">
        <el-table-column
            prop="Code"
            label="Code"/>
        <el-table-column
            prop="Message"
            label="Message"/>
      </el-table>

      <el-button type="primary" @click="onModifyCupValue()">
        Modify Cup Value
      </el-button>

      <br/>
      <br/>

    </el-form>
  </div>
</template>

<script>
import { Message, MessageBox } from "element-ui";
import MyFormItem from "@/views/loop-machine/component/myFormItem.vue";
import requestServiceBase from "@/utils/request-service-base";

export default {
  name: "EventApi",
  components: {MyFormItem},
  data() {
    return {
      activeTab: "API",
      isLoading: false,
      modifyCupValue: {
        userId: "",
        typeLb: "Lbq",
        modifyValue: 0,
        result: [],
        typeLbOption: [
          {
            value: "Lbq",
            label: "Lbq",
          },
          {
            value: "RbGrand",
            label: "RbGrand",
          },
        ],
      },
    }
  },
  async created() {
    this.loading = false;
  },

  methods: {
    async onModifyCupValue() {
      this.loading = true;
      try {
        this.modifyCupValue.result = [];
        let response  = await requestServiceBase(
            {
              url: `/maintain/user-profile/modify-cup-value`,
              method: `post`,
              data: {
                UserId: this.modifyCupValue.userId,
                TypeLb: this.modifyCupValue.typeLb,
                Value: this.modifyCupValue.modifyValue,
              }
            }
        );

        let showData = {
          Message: response.message,
          Code: response.code,
        };

        this.modifyCupValue.result.push(showData);
      }
      catch (ex) {
        Message({
          message: `Modify Cup error: ${ex}`,
          type: "error",
          duration: 5 * 1000,
        });
      }

      this.loading = false;
    },
  },
};
</script>